import { render, staticRenderFns } from "./BarConsultationsISTByOrientations.vue?vue&type=template&id=48463fca&"
import script from "./BarConsultationsISTByOrientations.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByOrientations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports